import { render } from "./verify-modal.vue?vue&type=template&id=254ce070&scoped=true"
import script from "./verify-modal.vue?vue&type=script&lang=js"
export * from "./verify-modal.vue?vue&type=script&lang=js"

import "./verify-modal.vue?vue&type=style&index=0&id=254ce070&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254ce070"]])

export default __exports__